import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsString } from 'class-validator';

export class PusherAuthorizeInputModel {
  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  public channel_name!: string;

  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  public socket_id!: string;
}
